<template>
  <div class="main">
    <div class="nav">
      <!-- <Nav :title="'费用列表'" :fixed="true"> </Nav> -->
      <div class="nav">
        <van-nav-bar
          title="费用列表"
          left-arrow
          :fixed="flexfalg"
          @click-left="onClickLeft"
        />
        <div class="top"></div>
      </div>
    </div>
    <van-notice-bar v-if="tips" left-icon="volume-o" :text="tips" />
    <div v-if="emptyflag">
      <van-empty description="暂无缴费信息" />
    </div>

    <div class="paycard" v-for="(item, index) in clinicIdInfo" v-else>
      <div class="head">
        <div>处方号:{{ item.RecipeSEQ }}</div>
        <div class="checkbox">
          <van-radio-group v-model="radio">
            <van-radio
              :name="index"
              @click.stop="
                getcheckitem(
                  item.Fee,
                  item.SeeID,
                  item.RecipeSEQ,
                  item.RegisterNo,
                  item.MTC
                )
              "
            ></van-radio>
          </van-radio-group>
        </div>
      </div>
      <div @click.stop="showPop(item.RecipeSEQ, item.PresDate)">
        <div class="Crow">
          <div>就诊人</div>
          <div>{{ name }}</div>
        </div>
        <div class="Crow">
          <div>流水号</div>
          <div>{{ item.SeeID }}</div>
        </div>
        <!-- <div class="Crow">
              <div></div>
              <div class="gold">未缴费</div>
            </div> -->
        <div class="Crow">
          <div>处方金额:</div>
          <div class="red">￥：{{ item.Fee | FinalPrice }}</div>
        </div>
        <div class="Crow">
          <div>门诊诊断:</div>
          <div>{{ item.Diagnosis }}</div>
        </div>
        <!-- <div class="Crow">
              <div>{{ item2.feeTypeName }}参考费</div>
              <div class="gold">￥{{ item2.recipeFee }}</div>
            </div> -->
        <div class="Crow">
          <div>{{ item.DeptName }}</div>
          <div>{{ item.PresDate }}</div>
        </div>
      </div>
    </div>

    <div class="last_item"></div>
    <div class="pay_list_foot" v-if="!emptyflag">
      <!-- <van-checkbox v-model="checked" @click="allcheck">全选</van-checkbox> -->
      <div
        v-if="healthcarepayflag"
        :class="healthcarepayflag ? 'pay_button_left' : 'pay_button'"
        @click="healthtest(false)"
      >
        医保结算
      </div>
      <div
        v-if="!emptyflag"
        :class="healthcarepayflag ? 'pay_button_left' : 'pay_button'"
        @click="healthtest(true)"
      >
        医保亲情付
      </div>
      <div
        :class="healthcarepayflag ? 'pay_button_right' : 'pay_button'"
        @click="go_pay"
      >
        自费结算
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import setOptions from "@/mixins/setOption";
import backindex from "@/mixins/backindex";
import { Toast } from 'vant'
export default {
  mixins: [setOptions, backindex],
  data() {
    return {
      timer: null,
      //微信支付参数
      appId: "",
      timeStampp: "",
      nonceStr: "",
      pacKage: "",
      signType: "",
      timer: null,
      paySign: "",
      //微信支付参数
      RecipeSEQ: "",
      fee: "",
      seeid: "",
      showpop: false,
      radio: null,
      flexfalg: true,
      emptyflag: false,
      testcheck: null,
      TotalPrice: 0,
      activeNames: ["1"],
      result: [],
      clinicIdInfo_checkeds: [],
      key: null,
      clientId: null,
      name: null,
      clinicIdInfo: {},
      recipeIdArr: [],
      //挂号流水号
      registerId: "",
      payWay: "",
      healthcarepayflag: false,
      RegisterNo: "",
      MTC:"",
      hosp_name:"",
      
      familyflag:null
    };
  },
  components: {
    Nav
  },
  filters: {
    FinalPrice(regFee) {
      let Fee = Number(regFee);
      return Fee.toFixed(2);
    }
  },
  mounted() {
    // console.log(this.fee,this.seeid);
    if (this.$route.query) {
      this.clientId = this.$route.query.clientId;
      // this.name = this.$route.query.name;
    }
    if (!this.clientId || this.clientId == "") {
      // this.Dialog();
      this.goconfUser();
      return;
    }
    // this.getPayList();
    this.gethealthcarepayflag();
    this.getPayWay();
  },
  methods: {
    async healthtest(familyflag) {
      if(this.MTC&&this.MTC!="1"&&this.MTC!="3"){
        this.$toast.fail("自费处方不允许医保结算");
        return;
      }
     
      if (this.radio == null) {
        this.$toast.fail("尚未选中处方");
        return;
      }
      let data = {
        familyflag,
        clientId:this.clientId,
        redirectUrl: `https://account.kmmds.top/healthcarepay?sSIID=${this.clientId}&iIPID=${this.RegisterNo}&name=${this.name}&recipes=${this.RecipeSEQ}`
      };
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/getpayAuthNo";
        await this.$axios_request.axios_request_body(
          "nodeserver", 
          url,
          "POST",
          data,
          res => {
            this.$hideLoad();
            if (res.status == 200 && res.data.url) {
              window.location.href = res.data.url;
            } else {
              this.$toast.fail("网络出错，稍后重试");
              return;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    async gethealthcarepayflag() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/gethealthcarepayflag";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          data => {
            this.healthcarepayflag = data.data;
            this.familyflag=data.familyflag
            this.getPayList();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          data => {
            this.payWay = data.data.objType[0].paykey;
            this.tips = data.tips.outpatientfee;
            this.hosp_name=data.data.hosp_name
            this.$hideLoad();
            //   console.log(this.vtypeflag)
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    // 微信支付
    onBridgeReady(appId, timeStamp, nonceStr, pacKage, signType, paySign) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: this.appId, //公众号名称，由商户传入
          timeStamp: this.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: this.nonceStr, //随机串
          package: this.pacKage,
          signType: this.signType, //微信签名方式：
          paySign: this.paySign //微信签名
        },
        res => {
          // this.$showLoad("请耐心等待，请勿返回");
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            this.$showLoad("支付确认中...");
            this.timer = setTimeout(() => {
              this.$hideLoad();
              this.$router.push({
                path: "/pay_history_D",
                query: {
                  clientId: this.clientId
                }
              });
            }, 5000);
          }
        }
      );
    },
    async go_pay() {
      if (this.radio == null) {
        this.$toast.fail("尚未选中处方");
        return;
      }

      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/recipePayD";
        let R_data = {
          clientId: this.clientId,
          total_fee: this.fee,
          preId: this.seeid,
          recipes: this.RecipeSEQ,
          payWay: this.payWay
        };
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          R_data,
          data => {
            console.log(data);
            this.$showLoad("支付确认中");
            this.appId = data.data.appId;
            this.timeStamp = data.data.timeStamp;
            this.nonceStr = data.data.nonceStr;
            this.pacKage = data.data.package;
            this.signType = data.data.signType;
            this.paySign = data.data.paySign;
            if (data.status == 200) {
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    this.onBridgeReady(
                      this.appId,
                      this.timeStamp,
                      this.nonceStr,
                      this.pacKage,
                      this.signType,
                      this.paySign
                    ),
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent(
                    "WeixinJSBridgeReady",
                    this.onBridgeReady(
                      this.appId,
                      this.timeStamp,
                      this.nonceStr,
                      this.pacKage,
                      this.signType,
                      this.paySign
                    )
                  );
                  document.attachEvent(
                    "onWeixinJSBridgeReady",
                    this.onBridgeReady(
                      this.appId,
                      this.timeStamp,
                      this.nonceStr,
                      this.pacKage,
                      this.signType,
                      this.paySign
                    )
                  );
                }
              } else {
                this.$hideLoad();
                this.onBridgeReady(
                  this.appId,
                  this.timeStamp,
                  this.nonceStr,
                  this.pacKage,
                  this.signType,
                  this.paySign
                );
              }
            } else {
              this.$toast.fail("支付出错请联系管理员");
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    showPop(RecipeSEQ, PresDate) {
      this.$router.push({
        path: "/pay_list_D_detail",
        query: {
          recipeSEQ: RecipeSEQ,
          recipeDate: PresDate
        }
      });
    },

    onClickLeft() {
      this.$router.push("/index");
    },

    async getPayList() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/querychargedrecipe";
        let medCardNo = this.clientId;
        let R_data = {
          medCardNo: medCardNo
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          R_data,
          data => {
            console.log(data);
            if (Object.keys(data.data.data.List.Item).length == 0) {
              this.emptyflag = true;
              this.$hideLoad();
              return;
            }
            this.clinicIdInfo = data.data.data.List.Item;
            if(!this.name) this.name=this.clinicIdInfo[0].PatientName
               this.$hideLoad();
            if (this.$route.query.flag && this.$route.query.flag == "2") {
              Toast.fail("获取授权码失败,请重新操作");
            }
          
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //go选择用户
    goconfUser() {
      this.$router.push("/patient_card_selectuser");
    },
    //单选
    getcheckitem(Fee, SeeID, RecipeSEQ, RegisterNo,MTC) {
      (this.RecipeSEQ = RecipeSEQ), (this.fee = Fee), (this.seeid = SeeID);
      this.RegisterNo = RegisterNo;
      this.MTC=MTC
      // console.log(Fee,SeeID)
      console.log(this.radio);
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top {
    height: 50px;
  }
  .pop {
    margin-top: 15px;
    .Prow {
      color: #747d8c;
      margin-left: 20px;
      margin-right: 20px;
      line-height: 30px;
      display: flex;
      font-size: 15px;
      justify-content: space-between;
      .gold {
        color: #e74c3c;
      }
      .green {
        color: #2ed573;
      }
    }
    .line {
      border-bottom: 1px solid #95a5a6;
    }
  }
}
.paycard {
  padding: 5px;
  width: 95%;
  display: flex;
  flex-direction: column;
  // border: 1px solid #5b8df6;
  border-radius: 15px;
  margin: 0px auto;
  margin-top: 10px;
  margin-bottom: 15px;
  box-shadow: 0 1px 3px #5b8df6;
  .red {
    color: red;
  }
}
.head {
  margin-left: 10px;
  margin-right: 10px;
  color: #5b8df6;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #5b8df6;
  font-size: 16px;
  line-height: 30px;
  .checkbox {
    margin-top: 5px;
  }
}
.content {
  width: 90%;
  display: flex;
  flex-direction: column;
  border: 1px solid #95a5a6;
  border-radius: 15px;
  margin: 0px auto;
}
.Crow {
  color: #747d8c;
  margin-left: 20px;
  margin-right: 20px;
  line-height: 30px;
  display: flex;
  font-size: 15px;
  justify-content: space-between;
  .gold {
    color: #e74c3c;
  }
  .green {
    color: #2ed573;
  }
}
.line {
  border-bottom: 1px solid #95a5a6;
}

.pay_list_foot {
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #aaaaaaaa;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  line-height: 70px;
  .pay_text {
    margin-left: 20px;
    color: #aaaaaa;
    .money {
      color: #e74c3c;
    }
  }
  .pay_button {
    background-color: #5b8df6;
    margin-right: 20px;
    width: 90%;
    margin: 0px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #ffffff;
  }
  .pay_button_right {
    background-color: #6994ef;
    margin-right: 20px;
    width: 30%;
    margin: 0px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #ffffff;
  }
  .pay_button_left {
    background-color: #00cc66;
    margin-right: 20px;
    width: 30%;
    margin: 0px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #ffffff;
  }
}
.last_item {
  margin-bottom: 70px;
}
.coll_title {
  color: #747d8c;
  display: flex;
  justify-content: space-between;
  width: 95%;
}
.radio {
  padding: 5px;
  width: 100%;
  box-shadow: 0 1px 3px #5b8df6;
  border-radius: 8px;
  color: #747d8c;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f7f8fa;
  font-size: 16px;
  line-height: 30px;
  .radio_title {
    margin-left: 5px;
  }
  .checkbox2 {
    margin-top: 5px;
    margin-right: 10px;
  }
  margin-bottom: 8px;
}
.van-cell {
  font-size: 18px;
}
</style>